import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
// Material UI icons
import HelpIcon from '@mui/icons-material/Help';
import SearchIcon from '@mui/icons-material/Search';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import PATHS from 'lib/navigation/paths';
import { useTranslation } from 'next-i18next';

const PREFIX = 'FAQSearch';

const classes = {
  root: `${PREFIX}-root`,
  rootBorder: `${PREFIX}-rootBorder`,
  title: `${PREFIX}-title`,
  helpIcon: `${PREFIX}-helpIcon`,
  description: `${PREFIX}-description`,
  textField: `${PREFIX}-textField`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.fogWhite,
    padding: theme.spacing(4, 4, 5, 4),
  },

  [`& .${classes.rootBorder}`]: {
    borderRadius: '15px 15px 0 0',
  },

  [`& .${classes.title}`]: {
    fontSize: theme.typography.pxToRem(31),
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(20),
    },
    [`& .${classes.helpIcon}`]: {
      marginRight: theme.spacing(2),
      verticalAlign: 'text-top',
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(25),
        verticalAlign: 'text-bottom',
      },
    },
  },

  [`& .${classes.helpIcon}`]: {},

  [`& .${classes.description}`]: {
    display: 'block',
    marginTop: '1.5rem',
    marginBottom: '1rem',
    color: theme.palette.grey.A000,
    textAlign: 'center',
  },

  [`& .${classes.textField}`]: {
    "& [class*='MuiFormLabel-root']": {
      color: theme.palette.grey[300],
    },
    "& [class*='MuiInputBase-root']": {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.secondary.main,
    },
  },
}));

const FAQSearch = ({ isContactUsPage }) => {
  const appNavigator = useAppNavigator();
  const { t } = useTranslation();
  const [value, setValue] = React.useState('');

  const handleSearch = () => {
    appNavigator.push(PATHS.faqs.index({ q: value }));
  };

  return (
    <Root
      className={`${classes.root} ${isContactUsPage && classes.rootBorder}`}>
      <Typography variant="h3" className={classes.title}>
        <HelpIcon className={classes.helpIcon} fontSize="large" />
        {t('common_layout_v2:contact_us_help.answered_questions')}
      </Typography>
      <Typography variant="body2" className={classes.description}>
        {t('common_layout_v2:contact_us_help.search_for_your_question')}
      </Typography>
      <TextField
        className={classes.textField}
        fullWidth
        label={t('common_layout_v2:faqs.search_placeholder')}
        variant="filled"
        color="secondary"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleSearch} size="large">
                <SearchIcon sx={{ color: 'secondary.dark' }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Root>
  );
};

export default FAQSearch;
